<template>
	<section>
        <template>
			<div class="margin-top-10">
                <vForm ref="form">
                <vFormItem label-width="100" label="SKU">
					<vInput readonly v-model="formData.sku"  />
				</vFormItem>
                <vFormItem label-width="100" :label="$t('global.common.quantity',{defaultValue:'数量'})">
					<vInput readonly v-model="formData.qty" />
				</vFormItem>
                <vFormItem label-width="100" label="建议处理方式" prop="goodsReturnType" :rules="required" >
					<vSelect clearable v-model="formData.goodsReturnType" @on-change="clear">
                        <vOption v-for="(item,index) in getPlanCustomHandleType" :key="index" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
				</vFormItem>
				<vFormItem label-width="100" label="更换后SKU" v-if="formData.goodsReturnType===4" prop="newSku" :rules="required">
					<vInput v-model="formData.newSku" readonly suffix="search" @on-icon-click="handleModal"></vInput>
				</vFormItem>
                <vFormItem label-width="100" :label="this.$t('global.common.notes', { defaultValue: '备注' })">
					<vTextarea clearable v-model="formData.remark" />
				</vFormItem>
                </vForm>
			</div>
            <div class="text-right">
                <vButton class="margin-right-10" theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
            </div>
		</template>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="getDetail"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
		</compModal>
	</section>
</template>

<script>
import { HttpAddProcessMode } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
import compErpsku from './erpsku'
export default {
	mixins: [mixin],
    props: ["params"],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
        compErpsku
	},
	data() {
		return {
			loading: false,
			id: this.params.id,
            headId:this.params.headId,
			formData: {
            },
			modalProps: {
				show: false,
			},
            close:this.params.show
		};
	},
	created() {
        this.formData.sku=this.params.sku
        this.formData.qty=this.params.qty
	},
	computed: {
        ...mapGetters('dictionary', []),
        required () {
            return [
                {
                    required: true,
                    message: this.$t('global.common.fill_required', { defaultValue: '请填写必填项' })
                }
            ]
        }
	},
	methods: {
        clear(){
            this.formData.newProductId='';
            this.formData.newsku='';
        },
		// 查找sku
		handleModal() {
			this.modalProps = {
				show: true,
				width: 1000,
				title: " 查找SKU",
				component: "compErpsku",
				showFooter: false,
				props: {
					startUp: true,
				},
				on: {
					"on-data": (row) => {
						const newProductId = row.id;
                        const newSku = row.sku
						this.formData = {
							...this.formData,newSku,newProductId
						};
						this.modalProps = {};
					}
				}
			}
		},
        async submit(){
            let flag = true;
                await this.$refs.form.validate(valid => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            HttpAddProcessMode({headId:this.headId,id:this.id,...this.formData}).then(res=>{
                this.loading = false;
                this.$emit('on-success')
            }).catch(err => {
                this.$VMessage.error(err.message);
            });
        },
		cancel() {
            this.$emit('on-success')
		}
	}
};
</script>
